class VerticalVideos {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.grid = document.querySelector('[data-vv-section="' + sectionId + '"]');
    this.modal = document.querySelector('[data-vv-modal="' + sectionId + '"]');

    if (!this.grid || !this.modal) return;

    this.items = Array.from(this.grid.querySelectorAll(".vv-item"));
    if (!this.items.length) return;

    if (this.modal.parentElement !== document.body) {
      document.body.appendChild(this.modal);
    }

    this.videoArea = this.modal.querySelector("[data-vv-video-area]");
    this.productArea = this.modal.querySelector("[data-vv-product-area]");
    this.muteBtn = this.modal.querySelector("[data-vv-mute]");
    this.minimizeBtn = this.modal.querySelector("[data-vv-minimize]");
    this.prevBtn = this.modal.querySelector("[data-vv-prev]");
    this.nextBtn = this.modal.querySelector("[data-vv-next]");
    this.counter = this.modal.querySelector("[data-vv-counter]");
    this.shareBtn = this.modal.querySelector("[data-vv-share]");
    this.progressFill = this.modal.querySelector("[data-vv-progress-fill]");

    this.currentIndex = 0;
    this.currentVideo = null;
    this.currentWrap = null;
    this.isMuted = true;
    this.isTransitioning = false;
    this.isMinimized = false;
    this.miniPlayer = null;
    this.lastFocused = null;
    this.touchStartY = 0;
    this._toastTimer = null;

    this._onKeyDown = this._onKeyDown.bind(this);
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchEnd = this._onTouchEnd.bind(this);
    this._onCarouselResize = this._onCarouselResize.bind(this);

    this.carouselTrack = this.grid.querySelector(".vv-carousel__track");
    this.carouselPrevBtn = this.grid.querySelector("[data-vv-carousel-prev]");
    this.carouselNextBtn = this.grid.querySelector("[data-vv-carousel-next]");
    this.carouselIndex = 0;
    this._resizeTimer = null;

    // drag state
    this._dragStartX = null;
    this._dragging = false;
    this._dragMoved = false;

    this._bindEvents();
    this._updateCarouselButtons();
    this._initLazyVideos();
    window.addEventListener("resize", this._onCarouselResize);
  }

  _bindEvents() {
    var self = this;

    this.items.forEach(function (item, index) {
      var btn = item.querySelector(".vv-thumb");
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        if (self._dragMoved) { e.preventDefault(); return; }
        self.open(index);
      });
    });

    this.modal.querySelectorAll("[data-vv-close]").forEach(function (el) {
      el.addEventListener("click", function () { self.close(); });
    });

    if (this.muteBtn)     this.muteBtn.addEventListener("click",     function () { self._toggleMute(); });
    if (this.minimizeBtn) this.minimizeBtn.addEventListener("click", function () { self._minimize(); });
    if (this.prevBtn)     this.prevBtn.addEventListener("click",     function () { self._navigate(-1); });
    if (this.nextBtn)     this.nextBtn.addEventListener("click",     function () { self._navigate(1); });
    if (this.shareBtn)    this.shareBtn.addEventListener("click",    function () { self._share(); });

    if (this.carouselPrevBtn)
      this.carouselPrevBtn.addEventListener("click", function () { self._carouselGoTo(self.carouselIndex - 1); });
    if (this.carouselNextBtn)
      this.carouselNextBtn.addEventListener("click", function () { self._carouselGoTo(self.carouselIndex + 1); });

    if (this.carouselTrack) {
      // ---- TOUCH ----
      this.carouselTrack.addEventListener("touchstart", function (e) {
        self._dragStartX = e.touches[0].clientX;
        self._dragging = true;
        self._dragMoved = false;
      }, { passive: true });

      this.carouselTrack.addEventListener("touchmove", function (e) {
        if (!self._dragging) return;
        if (Math.abs(e.touches[0].clientX - self._dragStartX) > 8) self._dragMoved = true;
      }, { passive: true });

      this.carouselTrack.addEventListener("touchend", function (e) {
        if (!self._dragging) return;
        var delta = self._dragStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 40) self._carouselGoTo(self.carouselIndex + (delta > 0 ? 1 : -1));
        self._dragging = false;
        setTimeout(function () { self._dragMoved = false; }, 50);
      }, { passive: true });

      // ---- MOUSE ----
      this.carouselTrack.addEventListener("mousedown", function (e) {
        self._dragStartX = e.clientX;
        self._dragging = true;
        self._dragMoved = false;
        self.carouselTrack.style.cursor = "grabbing";
        e.preventDefault();
      });

      document.addEventListener("mousemove", function (e) {
        if (!self._dragging) return;
        if (Math.abs(e.clientX - self._dragStartX) > 8) self._dragMoved = true;
      });

      document.addEventListener("mouseup", function (e) {
        if (!self._dragging) return;
        var delta = self._dragStartX - e.clientX;
        if (Math.abs(delta) > 40) self._carouselGoTo(self.carouselIndex + (delta > 0 ? 1 : -1));
        self._dragging = false;
        self.carouselTrack.style.cursor = "grab";
        setTimeout(function () { self._dragMoved = false; }, 50);
      });
    }
  }

  open(index) {
    if (this.isMinimized) { this._maximize(); return; }

    this.lastFocused = document.activeElement;
    this.currentIndex = index;

    this.modal.hidden = false;
    document.body.style.overflow = "hidden";

    document.addEventListener("keydown", this._onKeyDown);
    this.modal.addEventListener("touchstart", this._onTouchStart, { passive: true });
    this.modal.addEventListener("touchend", this._onTouchEnd, { passive: true });

    this._clearWraps();
    this._resetProgress();
    this.currentVideo = null;
    this.currentWrap = null;

    this._buildVideoSlide(index, 0, true);
    this._loadProduct(this.items[index]);
    this._updateNavButtons();
    this._updateCounter();

    requestAnimationFrame(function () {
      var closeBtn = this.modal.querySelector(".vv-modal__close-btn");
      if (closeBtn) closeBtn.focus();
    }.bind(this));
  }

  close() {
    if (this.isMinimized) { this._closeMiniPlayer(); return; }

    this._killCurrentVideo();
    this.modal.hidden = true;
    document.body.style.overflow = "";

    document.removeEventListener("keydown", this._onKeyDown);
    this.modal.removeEventListener("touchstart", this._onTouchStart);
    this.modal.removeEventListener("touchend", this._onTouchEnd);

    this._clearWraps();
    this._resetProgress();
    this.productArea.innerHTML = "";
    this.currentVideo = null;
    this.currentWrap = null;

    if (this.lastFocused && typeof this.lastFocused.focus === "function") {
      this.lastFocused.focus();
    }
  }

  _minimize() {
    if (!this.currentWrap) { this.close(); return; }
    if (!this.miniPlayer) this._createMiniPlayer();

    var slot = this.miniPlayer.querySelector("[data-vv-mini-slot]");
    slot.appendChild(this.currentWrap);

    this.modal.hidden = true;
    document.body.style.overflow = "";

    document.removeEventListener("keydown", this._onKeyDown);
    this.modal.removeEventListener("touchstart", this._onTouchStart);
    this.modal.removeEventListener("touchend", this._onTouchEnd);

    this.miniPlayer.hidden = false;
    this.isMinimized = true;
  }

  _maximize() {
    if (!this.miniPlayer || !this.currentWrap) return;

    this.videoArea.appendChild(this.currentWrap);

    this.modal.hidden = false;
    document.body.style.overflow = "hidden";

    document.addEventListener("keydown", this._onKeyDown);
    this.modal.addEventListener("touchstart", this._onTouchStart, { passive: true });
    this.modal.addEventListener("touchend", this._onTouchEnd, { passive: true });

    this.miniPlayer.hidden = true;
    this.isMinimized = false;

    requestAnimationFrame(function () {
      var closeBtn = this.modal.querySelector(".vv-modal__close-btn");
      if (closeBtn) closeBtn.focus();
    }.bind(this));
  }

  _closeMiniPlayer() {
    if (this.miniPlayer) {
      this.miniPlayer.hidden = true;
      var slot = this.miniPlayer.querySelector("[data-vv-mini-slot]");
      if (slot) slot.innerHTML = "";
    }
    this._killCurrentVideo();
    this._clearWraps();
    this._resetProgress();
    this.productArea.innerHTML = "";
    this.currentVideo = null;
    this.currentWrap = null;
    this.isMinimized = false;

    if (this.lastFocused && typeof this.lastFocused.focus === "function") {
      this.lastFocused.focus();
    }
  }

  _createMiniPlayer() {
    var mp = document.createElement("div");
    mp.className = "vv-mini-player";
    mp.setAttribute("hidden", "");
    mp.innerHTML =
      '<div class="vv-mini-player__slot" data-vv-mini-slot></div>' +
      '<div class="vv-mini-player__controls">' +
      '<button class="vv-mini-player__btn" type="button" aria-label="Expandir" data-vv-maximize>' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>' +
      "</button>" +
      '<button class="vv-mini-player__btn" type="button" aria-label="Fechar" data-vv-mini-close>' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>' +
      "</button>" +
      "</div>";

    document.body.appendChild(mp);

    var self = this;
    mp.querySelector("[data-vv-maximize]").addEventListener("click",   function () { self._maximize(); });
    mp.querySelector("[data-vv-mini-close]").addEventListener("click", function () { self._closeMiniPlayer(); });

    this.miniPlayer = mp;
  }

  _navigate(direction) {
    if (this.isTransitioning) return;
    var newIndex = this.currentIndex + direction;
    if (newIndex < 0 || newIndex >= this.items.length) return;

    this.isTransitioning = true;

    var oldWrap  = this.currentWrap;
    var oldVideo = this.currentVideo;

    var newWrap = this._buildVideoSlide(newIndex, direction, false);
    void newWrap.offsetWidth;

    newWrap.classList.add("is-transitioning");
    newWrap.style.transform = "translateY(0)";

    if (oldWrap) {
      oldWrap.classList.add("is-transitioning");
      oldWrap.style.transform = direction > 0 ? "translateY(-100%)" : "translateY(100%)";
    }

    this._resetProgress();

    var self = this;
    setTimeout(function () {
      if (oldVideo) { oldVideo.pause(); oldVideo.src = ""; }
      if (oldWrap)  oldWrap.remove();
      self.isTransitioning = false;
    }, 420);

    this.currentIndex = newIndex;
    this._loadProduct(this.items[newIndex]);
    this._updateNavButtons();
    this._updateCounter();
  }

  _buildVideoSlide(index, direction, immediate) {
    var item = this.items[index];
    var src  = item.getAttribute("data-video-src"); // FIX: era item.dataset.videoSrc

    var wrap = document.createElement("div");
    wrap.className = "vv-video-wrap";

    if (!immediate && direction !== 0) {
      wrap.style.transform = direction > 0 ? "translateY(100%)" : "translateY(-100%)";
    }

    if (src) {
      var video = document.createElement("video");
      video.className = "vv-modal__video";
      video.setAttribute("playsinline", "");
      video.muted   = this.isMuted;
      video.preload = "metadata";
      video.src     = src;

      var self = this;
      video.addEventListener("timeupdate", function () { self._updateProgress(video); });
      video.addEventListener("ended",      function () { self._onVideoEnded(); });

      wrap.appendChild(video);
      this.currentVideo = video;
      video.play().catch(function () {});
    } else {
      var ph = document.createElement("div");
      ph.className   = "vv-modal__no-video";
      ph.textContent = "Video nao disponivel";
      wrap.appendChild(ph);
      this.currentVideo = null;
    }

    if (this.isMinimized && this.miniPlayer) {
      this.miniPlayer.querySelector("[data-vv-mini-slot]").appendChild(wrap);
    } else {
      this.videoArea.appendChild(wrap);
    }

    this.currentWrap = wrap;
    return wrap;
  }

  _killCurrentVideo() {
    if (this.currentVideo) {
      this.currentVideo.pause();
      this.currentVideo.src = "";
      this.currentVideo = null;
    }
    this.currentWrap = null;
  }

  _clearWraps() {
    this.videoArea.querySelectorAll(".vv-video-wrap").forEach(function (el) { el.remove(); });
  }

  _updateProgress(video) {
    if (!this.progressFill || !video.duration) return;
    this.progressFill.style.width = (video.currentTime / video.duration) * 100 + "%";
  }

  _resetProgress() {
    if (this.progressFill) this.progressFill.style.width = "0%";
  }

  _onVideoEnded() {
    this._resetProgress();
    if (this.currentIndex + 1 < this.items.length) {
      this._navigate(1);
    } else {
      if (this.isMinimized) { this._closeMiniPlayer(); } else { this.close(); }
    }
  }

  _loadProduct(item) {
    this.productArea.innerHTML = "";
    var url = item.getAttribute("data-product-url"); // FIX: era item.dataset.productUrl
    if (!url) return;

    var title    = item.getAttribute("data-product-title")     || ""; // FIX
    var priceMin = item.getAttribute("data-product-price-min") || ""; // FIX
    var priceMax = item.getAttribute("data-product-price-max") || ""; // FIX
    var image    = item.getAttribute("data-product-image")     || ""; // FIX
    var price    = priceMin && priceMax && priceMin !== priceMax ? priceMin + " - " + priceMax : priceMin;

    var link = document.createElement("a");
    link.href = url;
    link.className = "vv-product-card";

    if (image) {
      var img = document.createElement("img");
      img.src = image; img.alt = title; img.width = 52; img.height = 52;
      img.loading = "lazy"; img.className = "vv-product-card__img";
      link.appendChild(img);
    }

    var info    = document.createElement("div");  info.className = "vv-product-card__info";
    var titleEl = document.createElement("span"); titleEl.className = "vv-product-card__title"; titleEl.textContent = title;
    var priceEl = document.createElement("span"); priceEl.className = "vv-product-card__price"; priceEl.textContent = price;

    info.appendChild(titleEl);
    info.appendChild(priceEl);
    link.appendChild(info);

    var cta = document.createElement("span");
    cta.className = "vv-product-card__cta";
    cta.setAttribute("aria-hidden", "true");
    cta.textContent = "+";
    link.appendChild(cta);

    this.productArea.appendChild(link);
  }

  _share() {
    var item       = this.items[this.currentIndex];
    var productUrl = item.getAttribute("data-product-url"); // FIX
    var shareUrl   = productUrl ? window.location.origin + productUrl : window.location.href;
    var title      = item.getAttribute("data-product-title") || document.title; // FIX
    var self       = this;

    if (navigator.share) {
      navigator.share({ title: title, url: shareUrl }).catch(function () {});
    } else {
      navigator.clipboard.writeText(shareUrl).then(function () {
        var toast = self.shareBtn.querySelector(".vv-modal__share-toast");
        if (!toast) return;
        toast.removeAttribute("hidden");
        clearTimeout(self._toastTimer);
        self._toastTimer = setTimeout(function () { toast.setAttribute("hidden", ""); }, 2000);
      }).catch(function () {});
    }
  }

  _toggleMute() {
    this.isMuted = !this.isMuted;
    if (this.currentVideo) {
      this.currentVideo.muted = this.isMuted;
      if (!this.isMuted) this.currentVideo.play().catch(function () {});
    }

    var mutedIcon = this.muteBtn.querySelector(".vv-icon--muted");
    var soundIcon = this.muteBtn.querySelector(".vv-icon--sound");

    if (this.isMuted) {
      if (mutedIcon) mutedIcon.removeAttribute("hidden");
      if (soundIcon) soundIcon.setAttribute("hidden", "");
      this.muteBtn.setAttribute("aria-label", "Ativar som");
    } else {
      if (mutedIcon) mutedIcon.setAttribute("hidden", "");
      if (soundIcon) soundIcon.removeAttribute("hidden");
      this.muteBtn.setAttribute("aria-label", "Desativar som");
    }
  }

  _updateNavButtons() {
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.items.length - 1;
  }

  _updateCounter() {
    if (this.counter) {
      this.counter.textContent = this.currentIndex + 1 + " / " + this.items.length;
    }
  }

  _onKeyDown(e) {
    if (e.key === "Escape")    { this.close();        return; }
    if (e.key === "ArrowUp")   { e.preventDefault();  this._navigate(-1); return; }
    if (e.key === "ArrowDown") { e.preventDefault();  this._navigate(1);  return; }
  }

  _onTouchStart(e) { this.touchStartY = e.touches[0].clientY; }
  _onTouchEnd(e) {
    var delta = this.touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(delta) > 60) this._navigate(delta > 0 ? 1 : -1);
  }

  // --- Carousel ---

  _carouselVisibleCount() {
    if (!this.carouselTrack || !this.items.length) return 1;
    var viewportW = this.carouselTrack.parentElement.offsetWidth;
    var gap       = parseFloat(getComputedStyle(this.carouselTrack).gap) || 0;
    var itemW     = this.items[0].offsetWidth + gap;
    return Math.max(1, Math.floor(viewportW / itemW));
  }

  _carouselGoTo(targetIndex) {
    if (!this.carouselTrack || !this.items.length) return;

    var visible = this._carouselVisibleCount();
    var max     = Math.max(0, this.items.length - visible);

    this.carouselIndex = Math.max(0, Math.min(targetIndex, max));

    var gap    = parseFloat(getComputedStyle(this.carouselTrack).gap) || 0;
    var itemW  = this.items[0].offsetWidth + gap;
    var offset = this.carouselIndex * itemW;

    var maxOffset = Math.max(0, this.carouselTrack.scrollWidth - this.carouselTrack.parentElement.offsetWidth);
    offset = Math.min(offset, maxOffset);

    this.carouselTrack.style.transform = "translateX(-" + offset + "px)";
    this._updateCarouselButtons();
  }

  _updateCarouselButtons() {
    if (!this.carouselPrevBtn || !this.carouselNextBtn) return;

    var visible = this._carouselVisibleCount();
    var max     = Math.max(0, this.items.length - visible);

    if (this.carouselIndex <= 0) {
      this.carouselPrevBtn.setAttribute("hidden", "");
    } else {
      this.carouselPrevBtn.removeAttribute("hidden");
    }

    if (this.carouselIndex >= max) {
      this.carouselNextBtn.setAttribute("hidden", "");
    } else {
      this.carouselNextBtn.removeAttribute("hidden");
    }
  }

  _initLazyVideos() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var src = video.getAttribute("data-src");
          if (src && !video.src) {
            video.src = src;
            video.play().catch(function () {});
          }
          observer.unobserve(video);
        }
      });
    }, { rootMargin: "200px" });

    this.items.forEach(function (item) {
      var video = item.querySelector(".vv-thumb__video[data-src]");
      if (video) observer.observe(video);
    });
  }

  _onCarouselResize() {
    clearTimeout(this._resizeTimer);
    var self = this;
    this._resizeTimer = setTimeout(function () {
      self._carouselGoTo(self.carouselIndex);
    }, 150);
  }
}

document.querySelectorAll("[data-vv-section]").forEach(function (grid) {
  new VerticalVideos(grid.dataset.vvSection);
});